import { Reducer } from 'interfaces'
import { GetCCStateAction } from 'components/features/creditCard/creditCardStore/actions'
import { CreditCardDataState } from 'components/features/creditCard/creditCardStore/state'

const INITIAL_STATE = {
  reward_balance: '0',
}
export const ccRewardsReducer: Reducer<CreditCardDataState['rewards']> = (prevState = INITIAL_STATE, action) => {
  switch (action.type) {
    case GetCCStateAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      return action.payload.response.rewards
    }
  }
  return prevState
}
